<div class="container-fluid w-100">
  <div class="row">
      <div class="col-md-12">
        <app-b2b-articulos-list boxLabel="Artículos" [b2bUsuario]="user.recurso" [properties]="properties"></app-b2b-articulos-list>
      </div>

  </div>
</div>
